import { CurrencyPipe } from '@angular/common';
import { Component, computed, input, model } from '@angular/core';
import { UiModule } from '../../../../components/ui.module';
import { BranchStatistics } from '../../../../types';

@Component({
  selector: 'app-branch-statistics',
  templateUrl: './grocery-ctp-branch-statistics.component.html',
  imports: [UiModule, CurrencyPipe],
})
export class GroceryCtpBranchStatisticsComponent {
  readonly statistics = input.required<BranchStatistics>();
  readonly period = model.required<number>();

  readonly periodOptions = [
    { label: 'Last 7 Days', value: 7 },
    { label: 'Last 30 Days', value: 30 },
    { label: 'Last 90 Days', value: 90 },
  ];

  public showCustomPeriod = computed(() => this.periodOptions.every((option) => option.value !== this.period()));

  formatGrowth(pct: number): string {
    const arrow = pct > 0 ? '↑' : pct < 0 ? '↓' : '—';
    const value = Math.abs(pct);
    return `${value}% ${arrow}`;
  }
}
